import React from "react";
import Navebar from "./Component/Layouts/Navebar/Navebar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Component/Home/Home";
import Footer from "./Component/Layouts/Footer/Footer";
import AboutPage from "./Component/Pages/ConatctUs/AboutPage";
import BlockChainPage from "./Component/Pages/BlockChain/BlockChainPage";
import GamePage from "./Component/Pages/GamePage/GamePage";
import MobleAppDevelopment from "./Component/Pages/MobileAppPage/MobleAppDevelopment";
import WebDevelopment from "./Component/Pages/WebPage/WebDevelopment";
import DigitalMarketing from "./Component/Pages/DigitalMarketing/DigitalMarketing";
import Graphic from "./Component/Pages/Graphic/Graphic";
import ServicesPage from "./Component/Pages/ServicesPage/ServicesPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContactUs from "./Component/Layouts/ConatctUs/ContactUs";
import DashBoard from "./Dashboard/DashBoard";
import Login from "./Dashboard/login";
import ScrollToTop from "./Component/Layouts/ScrollToTop";

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer position="top-right" theme="dark" />
      <Navebar />
      <Routes>
        <Route path="/admin/login" exact element={<Login />} />
        <Route path="/" exact element={<Home />} />
        <Route path="/about" exact element={<AboutPage />} />
        <Route path="/blockChain" exact element={<BlockChainPage />} />
        <Route path="/game" exact element={<GamePage />} />
        <Route path="/mobileapp" exact element={<MobleAppDevelopment />} />
        <Route path="/webdevelopment" exact element={<WebDevelopment />} />
        <Route path="/marketing" exact element={<DigitalMarketing />} />
        <Route path="/graphic" exact element={<Graphic />} />
        <Route path="/servicespage" exact element={<ServicesPage />} />
        <Route path="/contactus" exact element={<ContactUs />} />
        {/* ============================================================ */}
        <Route path="/admin/dashboard" exact element={<DashBoard />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
